import React from 'react';
import Icon from './Icon';

const CrossIcon = ({ size, color = 'currentColor', className, ...props }) => {
  return (
    <Icon size={size} color={color} className={className} {...props}>
      <path 
        d="M18 6L6 18" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M6 6L18 18" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default CrossIcon;
